// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../../../helpers';
import type { Theme } from '../../../types';
import svgToEnglish from '../svg-to-english';

type Props = {|
  title: string,
  description: string,
  icon?: string, // eslint-disable-line react/require-default-props
|};

const Header = styled<any, Theme>('header')`
  display: inline-flex;
  font-size: 2.25rem;
  line-height: 1em;
  margin-bottom: 0.15em;
  text-decoration: none;

  ${media.md(css`
    font-size: 3.125rem;
  `)}

  ${media.lg(css`
    font-size: 3.5rem;
  `)}
`;

const StyledTitle = styled<any, Theme>('h1')`
  color: ${props => props.theme.faq.categoryTitle.title.color};
  font-weight: ${props => props.theme.faq.categoryTitle.title.fontWeight};
  font-size: 0.667em;
  line-height: 1.495em;
`;

const Icon = styled<any, Theme>('i')`
  margin-right: 1rem;
  color: ${props => props.theme.faq.categoryTitle.iconColor};
`;

const StyledDescription = styled<any, Theme>('p')`
  color: ${props => props.theme.faq.categoryTitle.description.color};
  font-weight: ${props => props.theme.faq.categoryTitle.description.fontWeight};
  font-size: 1.125rem;
  line-height: 1.2em;
`;

const CategoryTitle = ({
  title,
  description,
  icon = '',
}: Props) => (
  <section>
    <Header>
      {icon && (<Icon className={`icon-${svgToEnglish(icon)}`} />)}
      <StyledTitle>{title}</StyledTitle>
    </Header>
    <StyledDescription>{description}</StyledDescription>
  </section>
);

export default CategoryTitle;
